"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLevelDisplayTextHelper = void 0;
var ListLevelDisplayTextHelper = (function () {
    function ListLevelDisplayTextHelper() {
    }
    ListLevelDisplayTextHelper.createDisplayFormatStringCore = function (placeholderIndices, text) {
        var sb = [];
        var textRange = ListLevelDisplayTextHelper.getTextRange(placeholderIndices, 0, text);
        if (textRange)
            sb.push(textRange);
        for (var i = 1; i < placeholderIndices.length - 1; i++) {
            var placeholderIndex = placeholderIndices[i];
            if (text.length <= placeholderIndex)
                break;
            sb.push('{');
            sb.push(text.charCodeAt(placeholderIndex).toString());
            sb.push('}');
            sb.push(ListLevelDisplayTextHelper.getTextRange(placeholderIndices, i, text));
        }
        return sb.join("");
    };
    ListLevelDisplayTextHelper.getTextRange = function (placeholderIndices, startPlaceHolderIndex, text) {
        var index = placeholderIndices[startPlaceHolderIndex] + 1;
        var result = text.substr(index, placeholderIndices[startPlaceHolderIndex + 1] - index);
        result = result.replace("{", "{{");
        result = result.replace("}", "}}");
        return result;
    };
    return ListLevelDisplayTextHelper;
}());
exports.ListLevelDisplayTextHelper = ListLevelDisplayTextHelper;
